import { render, staticRenderFns } from "./PaymentMethodSchoolCharge.vue?vue&type=template&id=05a970bb&"
import script from "./PaymentMethodSchoolCharge.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodSchoolCharge.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentMethodSchoolCharge.vue?vue&type=style&index=0&id=05a970bb&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports